define('ordersPaymentLinkModalView',[
  'module',
  'marionette',
  'underscore',
  'template!ordersPaymentLinkModalView'
], function(
  module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'payment-link-modal-view',

    ui: {
      total: '.total > input'
    },

    events: {
      'change @ui.total': 'onTotalChange'
    },

    serializeData: function() {
      var data = {};

      var pois = [];
      _.each(this.options.orders, function(order) {
        pois.push(order.get('purchaseOrderId'));
      }, this);

      data.pois = pois.join(', ');
      data.total = this.model.get('total');

      return data;
    },

    onTotalChange: function() {
      this.model.set('total', Number(this.ui.total.val()));
    }
  });
});
